<template>
  <div class="form_modal">
    <div class="work_calendar__modal" @click="closeSelect($event.target)">
      <span
        class="work_calendar__modal--close_btn"
        @click="$emit('close-modal')">
        Cerrar
      </span>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Evento</div>
        <input
        class="work_calendar__modal--input work_calendar__input"
        type="text"
        v-model="edited_task.title">
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Inicio</div>

        <div class="work_calendar__modal--inputs_container">
          <vue-timepicker
            class="data_card__info--select--time"
            style="margin:5px 0 !important; width: 53%;"
            format="hh:mm a"
            placeholder="10:00 am"
            v-model="selected_dates.start.time"
            :minute-interval="5"
            auto-scroll
            input-width="95%"
            hour-label="Horas" minute-label="mins" apm-label="AM/PM"
            close-on-complete
            hide-clear-button>
          </vue-timepicker>
          <date-picker
            class="work_calendar__modal--date_picker"
            v-model="selected_dates.start.date"
            type="date"
            name="date_in"
            :confirm="false"
            placeholder="Seleccionar fecha"
            format="DD/MM/YYYY">
          </date-picker>
        </div>
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Fin</div>

        <div class="work_calendar__modal--inputs_container">
          <vue-timepicker
            class="data_card__info--select--time"
            style="margin:5px 0 !important; width: 53%;"
            format="hh:mm a"
            placeholder="10:00 am"
            v-model="selected_dates.finish.time"
            :minute-interval="5"
            auto-scroll
            input-width="95%"
            hour-label="Horas" minute-label="mins" apm-label="AM/PM"
            close-on-complete
            hide-clear-button>
          </vue-timepicker>
          <date-picker
            class="work_calendar__modal--date_picker"
            v-model="selected_dates.finish.date"
            type="date"
            name="date_in"
            :confirm="false"
            placeholder="Seleccionar fecha"
            format="DD/MM/YYYY">
          </date-picker>
        </div>
      </div>

      <div class="work_calendar__modal--item_container">
        <div class="work_calendar__modal--title">Tipo</div>

        <div class="work_calendar__modal--select_input_container">
          <div class="work_calendar__modal--select_input work_calendar__input">

            <div
              class="work_calendar__modal--option" @click="choosing_type = !choosing_type">
              <span
                class="work_calendar__modal--task_type_color"
                :style="'background-color:'+taskColors[edited_task.task_type]">
              </span>
              {{ selected_type.type || edited_task.task_type }}
              <span style="position: absolute; right: 10px;" class="material-icons">
                {{ choosing_type ? 'expand_less' : 'expand_more' }}
              </span>
            </div>

            <div
              class="work_calendar__modal--option work_calendar__hover"
              v-for="task_type in taskTypes"
              v-if="choosing_type"
              @click="selectType(task_type)">
              <span
                class="work_calendar__modal--task_type_color"
                :style="'background-color: '+task_type.color">
              </span>
              {{ task_type.type }}
            </div>

          </div>
        </div>
      </div>

      <div class="work_calendar__modal--item_container" style="align-items: flex-start;">
        <div
          class="work_calendar__modal--title"
          style="padding-top: 12px;">
          Proveedor
        </div>

        <div class="work_calendar__modal--inputs_container" style="align-items: flex-start;">
          <div class="work_calendar__modal--select_input_container" style="width: 50%;">
            {{ selected_provider.name }}
            <div
              class="work_calendar__modal--select_input work_calendar__input"
              style="z-index: 1;">
              <div class="work_calendar__modal--option" @click="choosing_provider = !choosing_provider">
                {{ selected_provider.name }}
                <span style="position: absolute; top:10px; right: 10px;" class="material-icons">
                  {{ choosing_provider ? 'expand_less' : 'expand_more' }}
                </span>
              </div>

              <div style="overflow-y: scroll; max-height: 150px;">
                <div
                  class="work_calendar__modal--option work_calendar__hover"
                  v-for="provider in providers"
                  v-if="choosing_provider"
                  @click="selectProvider(provider)">
                  {{ provider.attributes.name }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="work_calendar__input"
            style="width: 47%; max-height: 150px; padding: 0;"
            :style="selected_provider.provider_info.staff.length > 3 ? 'overflow-y: scroll' : ''"
            v-if="selected_provider.provider_info && selected_provider.provider_info.staff.length > 0">

            <div
              class="work_calendar__modal--checkbox_option"
              v-for="staff in selected_provider.provider_info.staff"
              @click="toggleStaff(staff.id)">
              <v-checkbox
                class="work_calendar__modal--checkbox"
                color="blue"
                :input-value="edited_task.staff.includes(staff.id)"
                hide-details>'12:00 pm'
              </v-checkbox>

              <span style="width: 80%">
                {{ staff.name }}
              </span>
            </div>
          </div>

        </div>
      </div>

      <div class="work_calendar__modal--item_container" style="align-items: flex-start;">
        <div
          class="work_calendar__modal--title"
          style="margin-top: 12px;">
          Notas
        </div>
        <textarea
          class="work_calendar__modal--input work_calendar__input"
          style="height: 160px; resize: none; padding: 15px 12px;"
          wrap="hard"
          v-model="edited_task.notes">
        </textarea>
      </div>

      <div class="work_calendar__modal--item_container" style="margin-bottom: 20px;">
        <div class="work_calendar__modal--title">Soportes</div>

        <div class="work_calendar__modal--inputs_container">
          <label
            for="support_file_task"
            class="work_calendar__modal--support_file_uploader">
            <input id="support_file_task" type="file" style="display: none;" @change="uploadFile($event.target.files[0])">
            <span class="material-icons" style="margin-right: 3px;">attach_file</span>
            Cargar archivo
          </label>
        </div>
      </div>

      <div class="work_calendar__modal--support_file_container">
        <div v-for="(file, index) in uploaded_support_files" class="work_calendar__modal--support_file">
          <span :title="file.name">{{ file.name }}</span>
          <span
            class="material-icons"
            style="cursor: pointer; font-size: 14px;"
            @click="removeFile(index)">
            close
          </span>
        </div>
      </div>

      <div
        class="work_calendar__modal--item_container"
        style="justify-content: flex-end; margin-bottom: 0;">
        <button
          class="faccess_button my-3"
          style="padding: 0 50px;"
          @click="sendInfo()">
          Guardar
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  components: {
    VueTimepicker
  },
  props: ['show', 'providers', 'taskTypes', 'taskColors'],
  data(){
    return {
      choosing_type: false,
      choosing_provider: false,
      selected_provider: this.providers.filter(p => p.id == this.getSelectedTask().attributes.provider.id)[0].attributes,
      selected_type: '',
      selected_dates: {
        start: {
          time: moment(this.getSelectedTask().attributes.task_start).format('hh:mm a'),
          date: new Date(this.getSelectedTask().attributes.task_start)
        },
        finish: {
          time: moment(this.getSelectedTask().attributes.task_finish).format('hh:mm a'),
          date: new Date(this.getSelectedTask().attributes.task_finish)
        }
      },
      uploaded_support_files: [],
      edited_task: {
        title: this.getSelectedTask().attributes.title,
        task_type: this.getSelectedTask().attributes.task_type,
        task_start: '',
        task_finish: '',
        provider_id: this.getSelectedTask().attributes.provider.id,
        staff: this.getSelectedTask().attributes.staff.map(s => s.id),
        notes: this.getSelectedTask().attributes.notes,
        support_files: []
      },
    }
  },
  methods: {
    sendInfo(){
      try {
        const start_datetime = this.selected_dates.start.date ? new Date(moment(this.selected_dates.start.date).format().split('T')[0]+' '+this.selected_dates.start.time) : '',
              finish_datetime = this.selected_dates.finish.date ? new Date(moment(this.selected_dates.finish.date).format().split('T')[0]+' '+this.selected_dates.finish.time) : ''

        if(this.edited_task.title){
          if(start_datetime && finish_datetime){
            if(finish_datetime >= start_datetime){
              this.edited_task.task_start = start_datetime
              this.edited_task.task_finish = finish_datetime
              this.$emit('edit-task', this.edited_task)
              this.$emit('close-modal')

            } else throw { message: 'La fecha y hora de fin del evento debe ser posterior a la fecha de inicio' }

          } else throw { message: 'El evento debe tener fechas de inicio y fin asignadas' }

        } else throw { message: 'El evento debe tener título' }

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    uploadFile(file = ''){
      try {
        if(file != ''){
          const extension = file.type.split('/')[1]

          if(extension == 'png' || extension == 'jpeg' || extension == 'pdf'){
            if((extension == 'png' || extension == 'jpeg') && file.size > 2000000) throw { message: 'El tamaño de la imagen no debe ser mayor a 2MB' }
            else if(extension == 'pdf' && file.size > 5000000) throw { message: 'El tamaño del PDF no debe ser mayor a 5MB' }

            const reader = new FileReader()
            this.uploaded_support_files.push(file)
            reader.readAsDataURL(file)
            reader.onload = () => this.edited_task.support_files.push(reader.result)

          } else throw { message: 'Por favor adjunte un archivo que tenga alguno de los siguientes formatos: jpg, jpeg, png o pdf' }
        }

      } catch(e){
        alert(e.message)
      }
    },

    removeFile(index){
      this.uploaded_support_files.splice(index, 1)
      this.edited_task.support_files.splice(index, 1)
    },

    selectType(type){
      this.choosing_type = false
      this.selected_type = type
      this.edited_task.task_type = type.type
    },

    selectProvider(provider){
      this.choosing_provider = false
      this.selected_provider = provider.attributes
      this.edited_task.staff = this.edited_task.provider_id == provider.id ? this.edited_task.staff : []
      this.edited_task.provider_id = provider.id
    },

    toggleStaff(staff_id){
      if(this.edited_task.staff.includes(staff_id)){
        this.edited_task.staff.splice(this.edited_task.staff.indexOf(staff_id), 1)
      } else {
        this.edited_task.staff.push(staff_id)
      }
    },

    closeSelect(target){
      if(target.classList[0] != 'work_calendar__modal--option' && target.classList[0] != 'material-icons'){
        this.choosing_provider = false
        this.choosing_type = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/work_calendar/ModalTaskEdition.vue